import { render, staticRenderFns } from "./AnnotationCommentsModal.vue?vue&type=template&id=118c72f4&scoped=true"
import script from "./AnnotationCommentsModal.vue?vue&type=script&lang=js"
export * from "./AnnotationCommentsModal.vue?vue&type=script&lang=js"
import style0 from "./AnnotationCommentsModal.vue?vue&type=style&index=0&id=118c72f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118c72f4",
  null
  
)

export default component.exports